import React, { forwardRef, useEffect, useImperativeHandle, useState } from 'react'
import { Tree } from 'antd'
import type { TreeDataNode, TreeProps } from 'antd'
import { isArray } from 'lodash-es'
import { useUpdateEffect } from 'ahooks'
export default forwardRef(function TreeSelect(props: any, ref) {
  const { treeData, setTreeData, treeList } = props

  const onCheck = checkedKeysValue => {
    console.log('treeKeys', checkedKeysValue)
    setTreeData(checkedKeysValue);
  }
  return (
    <Tree
      checkable
      onCheck={onCheck}
      checkedKeys={treeData}
      treeData={treeList}
      defaultExpandAll={true}
      fieldNames={{
        title: 'dtlName',
        key: 'id'
      }}
    />
  )
})
